if (!customElements.get('home-why-spotlight')) {
  customElements.define(
    'home-why-spotlight',
    class HomeWhySpotlight extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));

        if (!this.track || this.cards.length === 0) return;

        this.onScroll = this.onScroll.bind(this);
        this.onDotClick = this.onDotClick.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        for (const dot of this.dots) {
          dot.addEventListener('click', this.onDotClick);
        }

        this.updateDots();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);

        for (const dot of this.dots) {
          dot.removeEventListener('click', this.onDotClick);
        }
      }

      onScroll() {
        window.requestAnimationFrame(() => this.updateDots());
      }

      onDotClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        const card = this.cards[index];
        if (!card) return;

        this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }

      updateDots() {
        if (this.dots.length === 0) return;

        const scrollLeft = this.track.scrollLeft;
        let activeIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
